<template>
  <b-card border-variant="secondary">
    <b-card-group deck>
      <b-card bg-variant="primary" text-variant="white">
        <v-icon name="users" scale="4" class="d-inline-block mr-2" />
        <div class="d-inline-block">
          <strong class="d-block">TOTAL USERS</strong>
          <span class="d-block">{{ totalUsers }}</span>
        </div>
      </b-card>

      <b-card bg-variant="info" text-variant="white">
        <v-icon name="cog" scale="4" class="d-inline-block mr-2" />
        <div class="d-inline-block">
          <strong class="d-block">SYSTEM SETTINGS</strong>
          <b-link :to="{ name: 'settings' }" class="d-block text-white">
            Open
            <v-icon name="external-link-alt" />
          </b-link>
        </div>
      </b-card>

      <!-- TODO: other system info -->
      <b-card bg-variant="white" text-variant="black">
        <b-card-text>Other system info here.</b-card-text>
      </b-card>

    </b-card-group>
  </b-card>
</template>
<script>
import { mapActions } from 'vuex';
import ResourceService from '@/services/ResourceService';

const resource = new ResourceService();

export default {
  name: 'MaintenanceIndex',
  data() {
    return {
      totalUsers: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    resource.get('/system/users/count')
      .then(({ success, count, message }) => next((vm) => {
        if (!success) {
          vm.setAlert({
            show: 5,
            variant: 'danger',
            fade: true,
            dismissible: true,
            message: message || 'An error occurred',
            icon: {
              name: 'exclamation',
            },
          });
          return;
        }
        vm.totalUsers = count || 0;
      }))
      .catch(() => next(vm => vm.setAlert({
        show: 5,
        variant: 'danger',
        fade: true,
        dismissible: true,
        message: 'An error occurred',
        icon: {
          name: 'exclamation',
        },
      })));
  },
  computed: {
    // fields() TODO: get admin settings and then build fields
  },
  methods: {
    ...mapActions([
      'setAlert',
    ]),
  },
};
</script>
